import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FaUserCircle,
  FaHome,
  FaBook,
  FaCar,
  FaCarSide,
} from "react-icons/fa";
import PasswordReset from "../components/PasswordReset";
import CustomerSelectModal from "../components/CustomerSelectModal";

function HomeNavBar() {
  const user = JSON.parse(localStorage.getItem("user"));
  const [showReset, setShowReset] = useState(false);
  const [showCustomers, setShowCustomers] = useState(false);
  const viewAs = localStorage.getItem("view_as");
  const role = localStorage.getItem("role");
  const customers = JSON.parse(localStorage.getItem("customers"));
  const customerName = localStorage.getItem("customer_name");

  const logout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  const switchBackToAdmin = () => {
  const adminToken = localStorage.getItem("admin_token");

  if (!adminToken) {
    alert("Admin session not found");
    return;
  }

  // restore admin session
  localStorage.setItem("token", adminToken);
  localStorage.removeItem("customer_id");
  localStorage.removeItem("roles");
  localStorage.removeItem("view_as");

  window.location.reload();
};

const typeId = localStorage.getItem("type_id");

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-dark px-3 sticky-top shadow-sm">

      <span className="navbar-brand fw-bold d-flex align-items-center gap-2">
  LINK JAPAN

  {viewAs && (
    <span
      className="badge bg-warning text-dark"
      style={{ fontSize: "0.7rem" }}
    >
      Viewing: {viewAs}
    </span>
  )}
</span>
      <button
        className="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarContent"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="navbarContent">

        {/* CENTER */}
        <ul className="navbar-nav mx-auto text-center">

          <li className="nav-item">
            <NavLink to="/dashboard" className={({ isActive }) =>
              isActive ? "nav-link active-link d-flex align-items-center gap-1"
                       : "nav-link d-flex align-items-center gap-1"
            }>
              <FaHome /> Dashboard
            </NavLink>
          </li>

          {Number(typeId) === 1 && (
  <li className="nav-item">
    <NavLink
      to="/ledger"
      className={({ isActive }) =>
        isActive
          ? "nav-link active-link d-flex align-items-center gap-1"
          : "nav-link d-flex align-items-center gap-1"
      }
    >
      <FaBook /> Account Summary
    </NavLink>
  </li>
)}

          <li className="nav-item">
            <NavLink to="/vehicle-stock" className={({ isActive }) =>
              isActive ? "nav-link active-link d-flex align-items-center gap-1"
                       : "nav-link d-flex align-items-center gap-1"
            }>
              <FaCar /> Vehicle Stock
            </NavLink>
          </li>

          <li className="nav-item">
            <NavLink to="/selected-vehicles" className={({ isActive }) =>
              isActive ? "nav-link active-link d-flex align-items-center gap-1"
                       : "nav-link d-flex align-items-center gap-1"
            }>
              <FaCarSide /> Selected Vehicles
            </NavLink>
          </li>

        </ul>

        {/* RIGHT */}

     <div className="ms-auto d-flex align-items-center gap-3">

  {/* Customer Name */}
  {customerName && (
    <div
      className="text-white fw-semibold"
      style={{
        maxWidth: "300px",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      }}
      title={customerName}
    >
      {customerName}
    </div>
  )}

  {/* User Dropdown */}
  <div className="dropdown">
    <button
      className="btn btn-dark dropdown-toggle d-flex align-items-center"
      data-bs-toggle="dropdown"
    >
      <FaUserCircle size={24} />
    </button>

    <ul className="dropdown-menu dropdown-menu-end">

      <li className="px-3 py-2">
        <div className="fw-bold">
          {user?.link_employee_id || localStorage.getItem("username")}
        </div>
        <div className="text-muted small">
          {localStorage.getItem("role")}
        </div>
      </li>

      <li><hr className="dropdown-divider" /></li>

      {role === "admin" && customers && (
        <li>
          <button
            className="dropdown-item"
            onClick={() => setShowCustomers(true)}
          >
            View As
          </button>
        </li>
      )}

      <li>
        <button
          className="dropdown-item"
          onClick={() => setShowReset(true)}
        >
          Password Reset
        </button>
      </li>

      {localStorage.getItem("view_as") && (
        <li>
          <button
            className="dropdown-item text-warning"
            onClick={switchBackToAdmin}
          >
            Switch Back to Admin
          </button>
        </li>
      )}

      <li>
        <button
          className="dropdown-item text-danger"
          onClick={logout}
        >
          Logout
        </button>
      </li>

    </ul>
  </div>

</div>
</div>

      {/* MODALS */}
      {showReset && (
        <PasswordReset onClose={() => setShowReset(false)} />
      )}

      {showCustomers && (
        <CustomerSelectModal
          customers={customers}
          onClose={() => setShowCustomers(false)}
        />
      )}

    </nav>
  );
}

export default HomeNavBar;